<template>
  <v-container class="container-points" pa-0>
    <v-row>
      <div class="page__title">
        <div>
          <h1><v-icon>mdi-shopping</v-icon> Twoje punkty:</h1>
        </div>
      </div>
    </v-row>

    <v-card flat>
      <ul class="list-style--none my-4 px-0 ">
        <li v-for="(containerPoints, index) in listActive" :key="'containerPoints_' + index" class="my-4">
          <div class="d-flex justify-space-between">
            <div class="d-flex">
              <div class="my-3">{{ containerPoints.pointContainer.name }}: {{ containerPoints.points }}</div>
            </div>

            <v-btn elevation="0" color="primary" @click="getHistory(containerPoints.pointContainer.id)">
              <v-icon left class="white--text">mdi-history</v-icon>

              Zobacz historię
            </v-btn>
          </div>

          <v-card v-if="containerPoints.pointContainer.id === containerHistoryId" xs12>
            <ul class="list-style--none pl-0 v-label--inactive">
              <li
                v-for="(pointHistory, index) in pointHistoryList"
                :key="'pointHistory_' + index"
                class="d-flex"
                @click="void 0"
              >
                <div>
                  <v-icon :class="pointHistory.points > 0 ? 'green--text' : 'red--text'">
                    {{ pointHistory.points > 0 ? 'mdi-arrow-top-right' : 'mdi-arrow-bottom-right' }}
                  </v-icon>
                </div>

                <div>
                  <div>{{ pointHistory.points }} pkt - Użycie: {{ pointHistory.benefit.name }}</div>

                  <small>
                    {{ pointHistory.created | dateFilter }}
                  </small>
                </div>
              </li>
            </ul>
          </v-card>
        </li>
      </ul>

      <div class="separate--before">
        Zakończone akcje punktowe:
      </div>

      <ul class="list-style--none my-4 px-0 ">
        <li v-for="(containerPoints, index) in listInactive" :key="'containerPoints_' + index" class="my-4">
          <div class="d-flex justify-space-between">
            <div class="d-flex">
              <div class="my-3">{{ containerPoints.pointContainer.name }}: {{ containerPoints.points }}</div>
            </div>
          </div>
        </li>
      </ul>
    </v-card>
  </v-container>
</template>

<script>
import { dateFilter, StateString } from '@witkac/kartamiejska-shared';
import { tryParseInt } from '@witkac/utils/tryParseInt';
import { mapState } from 'vuex';

import { LocalStorage } from '@/enums/storage.enum';

/**
 * @vuese
 * Lista wszystkich kontenerów na punkty w których użytkownik miał jakiekolwiek punkty
 * @group ContainerPoints
 */
export default {
  filters: { dateFilter },
  data() {
    return {
      containerHistoryId: null
    };
  },
  computed: mapState({
    listActive: state =>
      state.containerPoints.list.filter(containerPoints => containerPoints.pointContainer.state === StateString.ACTIVE),
    listInactive: state =>
      state.containerPoints.list.filter(
        containerPoints => containerPoints.pointContainer.state === StateString.INACTIVE
      ),
    count: state => state.containerPoints.count,
    pointHistoryList: state => state.pointHistory.list
  }),
  methods: {
    // @vuese
    // Pobranie historii kontenera
    getHistory(pointContainerId) {
      if (this.containerHistoryId === pointContainerId) {
        this.containerHistoryId = null;
        return;
      }
      this.$store
        .dispatch('pointHistory/list', {
          pointContainerId,
          profileId: tryParseInt(localStorage.getItem(LocalStorage.PROFILE_ID))
        })
        .then(() => (this.containerHistoryId = pointContainerId));
    }
  }
};
</script>

<style lang="scss">
.container-points {
  .list-style--none {
    list-style: none;
  }
}
</style>
